import { ModuleWithProviders, NgModule } from '@angular/core';
import { LongOperationModule } from 'src/app/common/long-operations/long-operations.module';
import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { SharedModule } from 'src/app/shared.module';
import { GridUsersListModule } from 'src/app/views/grid-user-list/grid-users-list.module';
import { ViewsModule } from 'src/app/views/views.module';
import { FormsConstructorModule } from '../../forms/forms-constructor.module';
import { PostsService } from '../posts/posts.service';
import { UsersSearchService } from '../search/users-search.service';
import { ConnectionsListComponent } from '../user-relation-requests/components/connections-list/connections-list.component';
import { UserRelationRequestModule } from '../user-relation-requests/relation-requests.module';
import { ProfileService } from './profile.service';
import { EditProfileComponent } from './user-profile/edit-profile/edit-profile.component';
import { EditProfileService } from './user-profile/edit-profile/edit-profile.service';
import { FormContentService } from './user-profile/edit-profile/form-content.service';
import { IndividualUserComponent } from './user-profile/edit-profile/user-type/individual-user/individual-user.component';
import { OrganizationComponent } from './user-profile/edit-profile/user-type/organization/organization.component';
import { UserTypeFormDirective } from './user-profile/edit-profile/user-type/user-type-form-directive/user-type-form.directive';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { OwnerProfileComponent } from './user-profile/view-profile/owner-profile/owner-profile.component';
import { RegularUserProfileComponent } from './user-profile/view-profile/regular-user-profile/regular-user-profile.component';
import { RoleOrganizationComponent } from './user-profile/view-profile/shared/organization/organization.component';
import { RoleDoctorComponent } from './user-profile/view-profile/shared/role-doctor/role-doctor.component';
import { RoleMedStaffComponent } from './user-profile/view-profile/shared/role-med-staff/role-med-staff.component';
import { RoleNavigateToOrganizationComponent } from './user-profile/view-profile/shared/role-navigation-organization/role-navigation-organization.component';
import { RolePatientComponent } from './user-profile/view-profile/shared/role-patient/role-patient.component';
import { RoleResearcherComponent } from './user-profile/view-profile/shared/role-researcher/role-researcher.component';
import { UserRoleTabComponent } from './user-profile/view-profile/shared/user-roles/user-roles.component';
import { UserBasicInfoComponent } from './user-profile/view-profile/user-basic-info/user-basic-info.component';
import { ViewProfileDirective } from './user-profile/view-profile/view-profile-directive/view-profile.directive';
import { ViewProfileComponent } from './user-profile/view-profile/view-profile.component';
import { ViewProfileService } from './user-profile/view-profile/view-profile.service';

@NgModule({
  imports: [
    SharedModule,
    FormsConstructorModule,
    PipesModule,
    ViewsModule,
    UserRelationRequestModule,
    GridUsersListModule,
    LongOperationModule,
  ],
  declarations: [
    EditProfileComponent,
    IndividualUserComponent,
    RoleOrganizationComponent,
    UserTypeFormDirective,
    UserProfileComponent,
    ViewProfileComponent,
    UserBasicInfoComponent,
    RegularUserProfileComponent,
    OrganizationComponent,
    OwnerProfileComponent,
    ViewProfileDirective,
    UserRoleTabComponent,
    RolePatientComponent,
    RoleResearcherComponent,
    RoleMedStaffComponent,
    RoleDoctorComponent,
    RoleNavigateToOrganizationComponent,
    ConnectionsListComponent,
  ],
  providers: [UsersSearchService],
})
export class ProfileModule {
  public static forRoot(): ModuleWithProviders<ProfileModule> {
    return {
      ngModule: ProfileModule,
      providers: [ProfileService, EditProfileService, FormContentService, ViewProfileService, PostsService],
    };
  }
}
